import { FC } from 'react';

export const SearchSugHead: FC = () => {
  return (
    <>
      <title>{'Lemon8'}</title>
    </>
  );
};
